import { styled } from '@mui/material/styles';
import { Box, Select, MenuItem } from '@mui/material';

export const LocationStepContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const LocationCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 1.5, // rounded-xl
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[1],
}));

export const LocationLabel = styled('label')(({ theme }) => ({
  display: 'block',
  fontSize: '0.875rem', // text-sm
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1.5),
}));

export const RequiredAsterisk = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
  marginLeft: theme.spacing(0.5),
}));

export const SelectContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: '100%',
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  fontSize: '0.875rem', // text-sm
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  transition: theme.transitions.create(['border-color', 'box-shadow']),
  '&:hover': {
    borderColor: theme.palette.success.main,
  },
  '&.Mui-focused': {
    borderColor: theme.palette.success.main,
    boxShadow: `0 0 0 2px ${theme.palette.success.main}33`,
  },
  '& .MuiSelect-select': {
    padding: 0,
    paddingRight: theme.spacing(3),
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

export const DropdownIcon = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: theme.spacing(1.5),
  transform: 'translateY(-50%)',
  pointerEvents: 'none',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
}));

export const DropdownArrow = styled('svg')(() => ({
  width: '1rem', // w-4
  height: '1rem', // h-4
  color: 'currentColor',
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.875rem',
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '0.875rem', // text-sm
}));

export const ErrorState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.error.light,
  color: theme.palette.error.contrastText,
  borderRadius: theme.shape.borderRadius,
  fontSize: '0.875rem', // text-sm
  textAlign: 'center',
}));
